import { Row } from '@tanstack/react-table';

export type GetRowChildren<T> = (row: T) => T[];
export type DepthMap = Map<string, number>;

export const explodeTreeRows = <T>(
  rows: Row<T>[],
  getRowId: (row: T) => string,
  getRowChildren: GetRowChildren<T>,
  expandedRowsIds: string[],
) => {
  let isAnyRowNested = false;
  const depthMap: DepthMap = new Map();
  const expandedSet = new Set(expandedRowsIds);
  const newRows: T[] = [];

  const dfs = (row: Row<T>, depth = 0) => {
    const id = depth === 0 ? getRowId(row.original) : getRowId(row as T);

    if (depth > 0) {
      newRows.push({
        ...row,
        original: row,
      } as T);
    } else {
      newRows.push(row as T);
    }

    depthMap.set(id, depth);
    const children =
      depth === 0 ? getRowChildren(row.original) : getRowChildren(row as T);

    if (children.length > 0) isAnyRowNested = true;
    if (expandedSet.has(id)) {
      children.forEach(r => dfs(r as Row<T>, depth + 1));
    }
  };

  rows.forEach(r => dfs(r));

  return { rows: newRows, isAnyRowNested, depthMap };
};
